module.exports = __webpack_public_path__ + "img/shipment-returns-m.be60854.webp";